export default __webpack_public_path__ + "media/images/Masto-J2-Halloween-e61593ccbe765a5f8d44f802de2d9b21.png";